import { useEffect, useRef, useState } from "react";
import { Form, Overlay, ProgressBar, Spinner, Tooltip , Toast, ToastContainer } from "react-bootstrap";

import { SignInTextInput } from "../../../shared/form/FormInput";
import { Validators } from "../../../shared/utils/Validators";
import { RenderAppLogo, RenderNoAuthHeaderText } from "../../../shared/components/ConditonalComponent";

import { passwordSet } from "../../../shared/settings/apiConfig";
import { postApi } from "../../../shared/services/apiHelper";

import './SetPassword.scss';
import '../NoAuth.scss';

const STRENGTH = {
    0: { name: '', color: 'white', progress: 0 },
    1: { name: 'Weak', color: 'danger', progress: 25 },
    2: { name: 'Weak', color: 'danger', progress: 25 },
    3: { name: 'Fair', color: 'warning', progress: 50 },
    4: { name: 'Good', color: 'info', progress: 75 },
    5: { name: 'Strong', color: 'success', progress: 100 }
};

const SetPassword = (props) => {

    const passwordInputRef = useRef(null);

    const [token, setToken] = useState('');
    const [passwordForm, setPasswordForm] = useState({
        newpassword: { value: '', valid: false, error: '', validators: [Validators.required()] },
        retypepassword: { value: '', valid: false, error: '', validators: [Validators.required()] }
    });
    const [formValid, setFormValid] = useState(false);
    const [passwordTypeMapper, setPasswordTypeMapper] = useState({ newpassword: 'password', retypepassword: 'password' });
    const [passwordStrength, setPasswordStrength] = useState({ show: false, status: 0, lower: false, upper: false, numeric: false, count: false, symbol: false });
    const [toast, showToast] = useState({show: false, type: '', message: ''});

    useEffect(() => {
        if ( typeof props.location.search === 'string' && props.location.search.includes('?token=') ) {
            setToken(props.location.search.replace('?token=', ''));
        }

        // TODO navigate or show a message when token is not present in the url
        // props.history.push('/not-found');
    }, []);

    useEffect(() => {
        setFormValid(Validators.validateForm(passwordForm));
    }, [passwordForm]);

    const onChangePasswordType = (name, type) => {
        setPasswordTypeMapper(prevState => {
            prevState[name] = type;
            return {...prevState};
        });
    };

    const onInputChange = (name, value) => {
        setPasswordForm(prevState => {
            const control = Validators.validateFormControl(prevState[name], value);
            
            if ( name === 'newpassword' ) {
                const strength = checkPasswordStrength(value);
                if ( value && strength.status != 5 ) {
                    control.error = 'Password should follow rules';
                    control.valid = false;
                }

                if ( prevState.retypepassword.value ) {

                    if ( value === prevState.retypepassword.value ) {
                        prevState.retypepassword.error = '';
                        prevState.retypepassword.valid = true;
                    } else {
                        prevState.retypepassword.error = 'Password does not match';
                        prevState.retypepassword.valid = false;
                    }
                }
            } else if ( passwordForm.newpassword.value && value && passwordForm.newpassword.value !== value ) {
                control.error = 'Password does not match';
                control.valid = false;
            }

            return {
                ...prevState,
                [name]: control
            }
        })
    };

    const showOrHidePasswordStrength = (show) => {
        setPasswordStrength(prevState => {
            prevState.show = show;
            return {...prevState};
        });
    };

    const checkPasswordStrength = (password) => {
        const lowerRegExp = new RegExp("^(?=.*[a-z])");
        const upperRegExp = new RegExp("^(?=.*[A-Z])");
        const numericRegExp = new RegExp("^(?=.*[0-9])");
        const lengthRegExp = new RegExp("^(?=.{8,15})");
        const symbolRegExp = new RegExp(/[ !@#$%^&*]/);

        let strength = {
            status: 0,
            lower: false,
            upper: false,
            numeric: false,
            symbol: false,
            count: false
        };

        /* check for lowercase character in password */
        if (lowerRegExp.test(password)) {
            strength.status += 1;
            strength.lower = true;
        }

        /* check for uppercase character in password */
        if (upperRegExp.test(password)) {
            strength.status += 1;
            strength.upper = true;
        }

        /* check for number in password */
        if (numericRegExp.test(password)) {
            strength.status += 1;
            strength.numeric = true;
        }

        /* check for Minimum 8 - Maximum 15 characters */
        if (lengthRegExp.test(password) && password.length < 16) {
            strength.status += 1;
            strength.count = true;
        }

        /* check for symbol in password */
        if (symbolRegExp.test(password)) {
            strength.status += 1;
            strength.symbol = true;
        }

        /* set password strength */
        setPasswordStrength(prevState => {
            return {...prevState, ...strength};
        });

        return strength;
    };

    const savePassword = () => {
        const payload = {
            context: token,
            password: btoa(passwordForm.newpassword.value)
        };

        postApi(passwordSet, {data: payload}).then(response => {
            showToast({message:"Your password has been successfully set! Please login",show:true,type:"success"})
            setTimeout(() => {
                showToast({show: false, type: '', message: ''})
                props.history.push('/');
            }, 2000);
        }).catch(error => {
            showToast({message:` ${error?.response?.data?.message}`,show:true,type:"danger"})
            setTimeout(() => {
                showToast({show: false, type: '', message: ''})
            }, 3000);
            console.log(error);
        });
    };

    return (
        <div className="set-password w-100" >
            <img className="noauth-bg-img" src={`${process.env.PUBLIC_URL}/static/images/signinbg.png`} alt="bg" />
            <div className='scontainer my-2'>
                <div className='sigincontent'>
                    <div className="d-flex align-items-center justify-content-center">
                        <img className="loader-img" src={`${process.env.PUBLIC_URL}/static/images/Logo_with_title.png`} alt="Logo" />
                    </div>
                    <div className="shadow-lg px-5 rounded">                        
                        <Form className="w-100 d-flex flex-column justify-content-center my-1" ref={passwordInputRef}>
                            <SignInTextInput type={passwordTypeMapper.newpassword} name="newpassword" label="New Password" placeholder="New Password" value={passwordForm.newpassword.value} error={passwordForm.newpassword.error} onChange={(event) => { onInputChange(event.target.name, event.target.value); }} setType={(type) => { onChangePasswordType('newpassword', type); }} onFocus={() => { showOrHidePasswordStrength(true); }} onBlur={() => { showOrHidePasswordStrength(false); }} />
                            <SignInTextInput type={passwordTypeMapper.retypepassword} name={'retypepassword'} label={'Retype Password'} placeholder={'Retype Password'} value={passwordForm.retypepassword.value} error={passwordForm.retypepassword.error} onChange={(event) => { onInputChange(event.target.name, event.target.value); }} setType={(type) => { onChangePasswordType('retypepassword', type); }} />
                            <button type="button" className="d-flex my-2 align-items-center justify-content-center btn btn-secondary sign-btn" onClick={savePassword} disabled={!formValid}>Save{false ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> : ''}</button>
                        </Form>

                        <Overlay show={passwordStrength.show} transition={false} id="overlay" target={passwordInputRef}
                            placement={window.innerWidth > 760 ? "right" : "bottom"}
>
                            <Tooltip className="set-password-overlay">
                                <div className="password-strength">
                                    <div className="font-weight-bold">
                                        Password Strength:&nbsp;
                                        <span className={`text-${STRENGTH[passwordStrength.status]['color']}`}>
                                            {STRENGTH[passwordStrength.status]['name']}
                                        </span>
                                    </div>
                                    <ProgressBar className="set-password-progress" animated variant={STRENGTH[passwordStrength.status]['color']} now={STRENGTH[passwordStrength.status]['progress']} />
                                    <ul className="list-unstyled password-strength-list">
                                        <div>
                                            <i className={passwordStrength.lower ? "fa fa-check text-success" : "fa fa-times"} />
                                            &nbsp;Atleast 1 Lowercase (a-z)
                                        </div>
                                        <div>
                                            <i className={passwordStrength.upper ? "fa fa-check text-success" : "fa fa-times"} />
                                            &nbsp;Atleast 1 Uppercase (A-Z)
                                        </div>
                                        <div>
                                            <i className={passwordStrength.numeric ? "fa fa-check text-success" : "fa fa-times"} />
                                            &nbsp;Atleast 1 Number (0-9)
                                        </div>
                                        <div>
                                            <i className={passwordStrength.count ? "fa fa-check text-success" : "fa fa-times"} />
                                            &nbsp;Between 8 to 15 Characters
                                        </div>
                                        <div>
                                            <i className={passwordStrength.symbol ? "fa fa-check text-success" : "fa fa-times"} />
                                            &nbsp;Atleast 1 Symbol Character
                                        </div>
                                        <div>Allowed Symbol Characters (!, @, #, $, %, ^, &, *)</div>
                                    </ul>
                                </div>
                            </Tooltip>
                        </Overlay>
                    </div>
                </div>
            </div>

            <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }} >
                <Toast show={toast.show} bg={toast.type} autohide={true} delay={2000}>
                    <Toast.Body className="text-white">
                        {toast.message}
                    </Toast.Body>
                </Toast>
            </ToastContainer>
        </div>
    )
};

export default SetPassword;